import React from 'react';
import { HiArrowUpRight } from 'react-icons/hi2';

const TECH_STYLES = {
  Web3: 'chip-web3',
  React: 'chip-react',
  Solidity: 'chip-solidity',
  JavaScript: 'chip-javascript',
  'Oracle APEX': 'chip-apex',
  'PL/SQL': 'chip-plsql',
  Less: 'chip-less',
  Jquery: 'chip-jquery',
};

const ProjectCard = ({ title, description, url, thumbnail, tags }) => {
  return (
    <a className="project-card" href={url} rel="noreferrer" target="_blank">
      <article className="project-copy">
        <div className="project-head">
          <h3 className="project-title">{title}</h3>
          <span className="project-open">
            View
            <HiArrowUpRight size={14} />
          </span>
        </div>
        <p className="project-desc">{description}</p>
        <div className="tag-row">
          {tags.map((tag) => (
            <span key={`${title}-${tag}`} className={`tech-chip ${TECH_STYLES[tag] || 'chip-default'}`}>
              {tag}
            </span>
          ))}
        </div>
      </article>
      <div className="project-visual">
        <img alt={`Thumbnail for ${title}`} src={thumbnail} className="project-thumb" loading="lazy" />
      </div>
    </a>
  );
};

export default ProjectCard;
